module.exports = __webpack_public_path__ + "static/media/logo-up.8c79cf22.png";